import {apiRegister} from '../../common/api';

import {isNumber, isPlain, isArray} from '../../common/utils';
import {ERR_REQ_CUP_ID, ERR_REP_CUP_PLAYER, ERR_REQ_CID, ERR_REP_CUP_PLAYER_LIST} from '../../common/const';

/*
协议Id 
370
项目 
模块 
方式 
https 
命令（路径） 
/award/klinev1/cupplayer/
说明
斗k场用户信息
请求参数
参数名称	参数类型	说明
cupId	int	场id
*/

const dkCupPlayer = apiRegister('dk-cup-player', {
  protoId: 370,
  path: '/award/klinev2/cupplayer/',
  checkQuery(Q) {
    if (!isNumber(Q.cupId)) {
      return ERR_REQ_CUP_ID; // 参数错误
    }
    return 0;
  },
  checkResult({cupPlayerInfo}) {
    if (!isPlain(cupPlayerInfo)) {
      return ERR_REP_CUP_PLAYER; // 数据格式非法
    }
    return 0;
  },
  formatResult({cupPlayerInfo}) {
    return {
      cupPlayer: cupPlayerInfo
    }
  }
});

// 接口
export const dkCupPlayerLoad = dkCupPlayer.send;


/*
协议Id 
921
项目 
模块 
方式 
https 
命令（路径） 
/award/match/mycupplayers/
说明
我的初赛中场信息(status字段是2时表示完成了此擂台)
请求参数
参数名称	参数类型	说明
cId	int	比赛配置id

*/

const dkCupPlayers = apiRegister('dk-cup-players', {
  protoId: 921,
  path: '/award/match/mycupplayers/',
  checkQuery(Q) {
    if (!isNumber(Q.cId)) {
      return ERR_REQ_CID; // 参数错误
    }
    return 0;
  },
  checkResult({list}) {
    if (!isArray(list)) {
      return ERR_REP_CUP_PLAYER_LIST; // 数据格式非法
    }
    return 0;
  }
});

// 接口
export const dkCupPlayersLoad = dkCupPlayers.send;
